import React from "react";
import { Card } from "react-bootstrap";

const LeadsDetailsHeader = ({ leadsUserData = {} }) => {
  return (
    <Card className="p-4 mb-0">
      <div className="d-flex justify-content-center flex-column gap-2 mb-4">
        <h5 className="m-0 p-0 fw-bold">{leadsUserData?.name || ""}</h5>
        <p className="m-0 p-0">{leadsUserData?.org_name || ""}</p>
      </div>

      <div className="row">
        <div className="col-md-3 col-sm-6 col-xs-12">
          <h6 className="fw-bold">Registration No.</h6>
          <p>{leadsUserData?.registration_no || ""}</p>
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <h6 className="fw-bold">Registration Body</h6>
          <p>{leadsUserData?.registration_body || ""}</p>
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <h6 className="fw-bold">State</h6>
          <p>{leadsUserData?.state || ""}</p>
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <h6 className="fw-bold">Specialty</h6>
          <p>{leadsUserData?.speciality || ""}</p>
        </div>
      </div>
    </Card>
  );
};

export default LeadsDetailsHeader;
